import { SecondaryStylingDTO } from 'generated/leaderboard-client';

import { SecondaryStyling } from './secondary-styling';

export abstract class SecondaryStylingModelConverter {
  static fromApiToDomain(source: SecondaryStylingDTO | undefined): SecondaryStyling | undefined {
    if (!source) {
      return undefined;
    }

    return {
      rules: source.rules ?? [],
      enabled: !!source.enabled,
      sampleMetrics: source.sampleMetrics,
    };
  }

  static fromDomainToApi(source: SecondaryStyling | undefined): SecondaryStylingDTO | undefined {
    if (!source) {
      return undefined;
    }

    return {
      rules: source.rules,
      enabled: source.enabled,
      sampleMetrics: source.sampleMetrics,
    };
  }
}
